import React, { useState } from 'react';
import { uniqBy } from 'lodash';
import { FloDropdown, FloDropdownProps, FloFilterGroup } from 'components';
import { FloDropdownOption } from 'components/FloDropdown';

interface DropdownWrapperProps extends FloDropdownProps {
  reinitList: () => void;
  groupLabel?: string;
  onClear?: () => void;
}

export const FloGroupedDropdown: React.FC<DropdownWrapperProps> = React.memo(({
  onClear,
  groupLabel,
  options,
  onChange,
  reinitList,
  ...rest
}) => {
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState<FloDropdownOption[]>([]);

  const dropdown = <FloDropdown
    {...rest}
    inputValue      = {search}
    onInputSearch   = {newValue => setSearch(newValue)}
    onChange        = {e => {
      onChange(e);
      setSelected(e || []);
      if (search !== '') {
        setSearch('');
        reinitList();
      }
    }}
    options         = {uniqBy([
      ...options,
      ...selected
    ], d => d.value)}
  />;

  return (onClear && groupLabel) ?
      <FloFilterGroup label={groupLabel} onClear={() => {
        onClear();
        setSearch('');
        setSelected([]);
      }}>
        {dropdown}
      </FloFilterGroup>
    :
      dropdown;
});